import React, { useEffect, useState } from 'react';
import { ButtonSizeEnum } from '../button';
import { Tabs, Tab } from '../tabs';
import { ProposalHead } from './components/proposal-head';
import { Button } from './components/proposal-tabs.styled';
import { ProposalContent } from './components/proposal-content';
import { ProposalTabsPropTypes, ProposalTabsDefaultValues } from './proposal-tabs.prop-types';
export const LoanProposalTab = () => React.createElement("div", null);
export const LoanProposalTabs = ({ iso = 'COP', labels, onSubmit, isLoading, children, defaultSelected, onChange, hiddenRows }) => {
    const proposals = [];
    const [tabs, setTabs] = useState([]);
    const [defaultTab, setDefaultTab] = useState(0);
    const [selectedProposal, setSelectedProposal] = useState(null);
    useEffect(() => {
        const childrenTabs = React.Children.toArray(children);
        if (childrenTabs.length) {
            childrenTabs.map((tab, index) => {
                proposals.push(tab.props.proposal);
                // Set default tab selected
                if (tab.props.proposal.loanProposalId === defaultSelected) {
                    setDefaultTab(index);
                    handleChange({ proposal: tab.props.proposal });
                }
            });
            buildTabs();
            !defaultSelected && handleChange({ proposal: childrenTabs[0].props.proposal });
        }
    }, [children.length]);
    const { noticeLabel, actionLabel } = labels;
    const tabHead = (isSelected, term) => (React.createElement(ProposalHead, { term: term, isSelected: isSelected, noticeLabel: noticeLabel }));
    const buildTabs = () => {
        const proposalTabs = proposals.map((proposal) => {
            return ({
                proposal,
                key: proposal.loanProposalId
            });
        });
        setTabs(proposalTabs);
    };
    const handleChange = ({ proposal }) => {
        setSelectedProposal(proposal);
        onChange && onChange(proposal);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { defaultSelected: defaultTab, onChange: handleChange }, tabs.map((tab) => React.createElement(Tab, { key: tab.key, tabKey: tab.key, proposal: tab.proposal, headComponent: (isSelected) => tabHead(isSelected, tab.proposal.term) },
            React.createElement(ProposalContent, { fractionDigits: iso === 'COP' ? 0 : 2, iso: iso, proposal: tab.proposal, labels: labels, hasWarranty: !!tab.proposal.totalGuarantee, hiddenRows: hiddenRows })))),
        React.createElement(Button, { onClick: () => onSubmit(selectedProposal), isLoading: isLoading, size: ButtonSizeEnum.Large }, actionLabel)));
};
LoanProposalTabs.propTypes = ProposalTabsPropTypes;
LoanProposalTabs.defaultProps = ProposalTabsDefaultValues;
//# sourceMappingURL=proposal-tabs.js.map